module.exports = __webpack_public_path__ + "/bundle/asset/U1_04-3e230cdfe63551909ed4d2b852492490.gif";